import React from 'react';

export default class Intervention extends React.Component {
  render() {
    return <div classname="content">
      <h1 classname="title is-3">intervention</h1>
      <img src="/assets/images/step+6.jpeg" />
      <p>engaged practice recommends making a written <b>collaborative care plan</b>.  this document includes the specifics of the current interventions and how the outcome will be measured. </p>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/more/Intervention.js